import styled from "styled-components";

export const FiltersWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  transition: all ease-in-out 0.5s;
  max-height: ${(props) => (props.$open ? '500px' : '0')};
  margin-bottom: ${(props) => (props.$open ? '0' : '-20px')};
  border: ${(props) => (props.$open ? '1px solid var(--border-color)' : '0px solid transparent')};
  opacity: ${(props) => (props.$open ? '1' : '0')};
  visibility: ${(props) => (props.$open ? 'visible' : 'hidden')};
`;

export const FiltersForm = styled.form`
  display: grid;
  grid-template-columns: ${props => `repeat(${props.$cols || 5}, minmax(0, 1fr))`};
  gap: 10px;
  padding: 20px;

  @media only screen and (max-width: 1023px) {
    /* grid-template-columns: repeat(4, minmax(0, 1fr)); */
    grid-template-columns: ${props => `repeat(${props.$cols || 4}, minmax(0, 1fr))`};
  }

  @media only screen and (max-width: 767px) {
    /* grid-template-columns: repeat(3, minmax(0, 1fr)); */
    grid-template-columns: ${props => `repeat(${props.$cols - 1 || 3}, minmax(0, 1fr))`};
  }

  @media only screen and (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const FilterFormActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  /* padding-top: 20px; */
`;